<template>
    <div>
      <div class="box-margin">
        <Card>
          <Form
            :model="formItem"
            :label-width="100"
            label-position="left"
            :disabled="prevent"
          >
            <Row style="margin-bottom: 0">
              <Col span="5" >
                <FormItem label="开始年度">
                  <Date-picker
                    v-model="formItem.beginyear"
                    type="year"
                    placeholder=""
                    :editable='false'
                  ></Date-picker>
                </FormItem>
              </Col>
              <Col span="5" >
                <FormItem label="结束年度">
                  <Date-picker
                    v-model="formItem.endyear"
                    type="year"
                    placeholder=""
                    :editable='false'
                  ></Date-picker>
                </FormItem>
              </Col>
              <Col span="1" offset="1">
                <Button type="primary"><!-- 检索 -->{{$t('Search')}}</Button>
              </Col>
            </Row>
          </Form>
          <div style="display:flex">
            <Checkbox v-model="tableAll" @on-change="tableAllChange">全部</Checkbox>
            <Checkbox-group v-model="tableColumnsChecked" @on-change="changeTableColumns" >
                <Checkbox label="achgrade" >建议绩效等级级别</Checkbox>
                <Checkbox label="Challengegrade">建议挑战等级级别</Checkbox>
                <Checkbox label="comment" >评语</Checkbox>
            </Checkbox-group>
          </div>
        </Card>
        
        <Table
          border
          :columns="columns1"
          :no-data-text="$t('noData')"
          :data="data1"
          :loading="modal_loading"
        >
        </Table>
        <Page style="display: flex;justify-content: flex-end;margin-top: 20px;" :current="pageInfo1.pageNo" :total="pageInfo1.itemCount" @on-change="pageChange1" />
      </div>
    </div>
</template>
  <script>
  import DateUtil from "../../../util/DateUtil";
  import ModelUtils from "../../../util/ModelUtil";
  import axios from "axios";
  export default {
    data() {
      return {
        formItem: {},
        pageInfo1: {
                  itemCount: 0,
                  pageNo: 1,
                  pageSize: 10,
              },
        filter: {},
        pageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
        },
        mxPageInfo: {
          itemCount: 0,
          pageNo: 1,
          pageSize: 10,
        },
        totalNum: 0,
        prevent: false,
        modal_loading: false,
        config: false,
        selRow: {},
        titleText: this.$t('share.selectPeople'),
        applyText: this.$t('leavePaid.applicationDetails'),
        applyVisiable: false,
        date: new DateUtil(),
        columns1: [],
        data1: [
            {
                year : "2022",
                achgrade:"B+",
                Challengegrade : "17H",
                comment : "Very Good"
            }
        ],
        rsztList: [],
        tableColumnsChecked:['achgrade','Challengegrade','comment'],
        tableAll:true,
      };
    },
    watch: {},
    mounted() {
      
    },
    created(){
      this.changeTableColumns();
    },
    updated(){
    //   this.empty();
    },
    methods: {
     pageChange1(){},
      getTable2Columns (){
        const table2ColumnList ={
          year:{
            title: "年度",
            key: "year",
            align: "center",
            fixed: "left"
          },
          achgrade:{
            title: "建议绩效等级级别",
            key: "achgrade",
            align: "center",
            fixed: "left"
          },
          Challengegrade:{
            title: "建议挑战等级级别",
            key: "Challengegrade",
            align: "center",
            fixed: "left"
          },
          comment:{
            title: "评语",
            key: "comment",
            align: "center",
            fixed: "left"
          }
        }
        let data = [table2ColumnList.year];
        this.tableColumnsChecked.forEach(col => data.push(table2ColumnList[col]));
        return data;
      },
      changeTableColumns(){
        if((this.getTable2Columns().length-1)<3){
          this.tableAll=false
        }else{
          this.tableAll=true
        }
        this.columns1 = this.getTable2Columns();
      },
      tableAllChange(val){
        val?this.tableColumnsChecked=['achgrade','Challengegrade','comment']:this.tableColumnsChecked=[]
        this.changeTableColumns()
      }
    },
  };
  </script>
  <style  scoped>
  .box-margin {
    margin-bottom: 20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/MyAchGrade.vue